import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthApiService } from '../../services/api/auth/auth-api.service';
import { NavigationManagerService } from '../../services/platform/ionic/navigation-manager.service';
import { RoutesEnum } from '../../shared/enum/routes.enum';

export const sessionGuard: CanActivateFn = () => {
  const auth = inject(AuthApiService);
  const navigationManager = inject(NavigationManagerService);

  if (auth.userIsLogIn()) {
    return true;
  }

  navigationManager.navigateRoot(RoutesEnum.onboarding, false);
  return false;
};
